import i18n from './index.js'
export default {//意大利文
  translateText: {
    shoppingcart: "Carrello",
    loginorrefisterText: "Login/Registrazione",
    logoutText: "uscita logoutttel ",
    personcenterText: "centro personale ",
    placeholderText: "Seleziona",
    loginText: "login",
    registerText: "registration",
    emailText: "cassetta postale",
    pwdText: "password",
    forgetpwdText: "dimentica la parola d’ordine?",
    nameText: "Nome",
    surnameText: "Cognome",
    mobileText: "Phone",
    setPwdText: "Imposta password",
    countryText: "Società",
    company: "Compleanno",
    birthday:"Year",
    yearText:"Year",
    mouthText:"Month",
    dayText:"Day",
    confirmpwdText: "Confirm Password",
    agreeText1: "Ho letto e accettato",
    agreeText2: "Condizioni d'uso",
    agreeText3: "e",
    agreeText4: "Informativa sulla privacy",
    agreeText5: "e acconsento che parte dei miei dati personali saranno trattati all'estero secondo l'informativa sulla privacy.",
    emailplaceholder: 'Inserisci e-mail',
    subscribetitleText: 'Iscriviti alla nostra newsletter',
    subscribeText: 'Subscribe',
    shareToText: 'Share to',
    searchText: 'Search',
    subtractmoneyText: "Riduci 600 al massimo",
    magnanimitycouponText: "Un gran numero di coupon ti aspettano per raccogliere",
    drawText: "Get it now",
    discountText: "Too much discount",
    purchaseText: "Buy Now",
    composecouponText: "Combined purchase",
    manyDiscountsText: "Many discounts",
    recommendtitleText: "Recommended for you",
    hotsaleproductyitleText: "Prodotti caldi",
    guessLiketitleText: "Indovinate che vi piace",
    NoDataText: "Nessun dato",
    appraiseText: "Comment",
    certificate: "certificato",
    collectText: "Collection",
    addCartText: "Aggiungi al carrello",
    enterkeywordsText: "Enter keywords",
    useNowText: "Use now",
    vouchernoText: "Voucher No.",
    placeholderyearText:"Select a year",
    placeholdermouthText:"Select month",
    placeholderdayText:"Select day",
    // 优惠券页面
    breadcrumbItemText1: 'Super',
    breadcrumbItemText2: 'Level',
    breadcrumbItemText3: 'Large',
    breadcrumbItemText4: 'Fu',
    breadcrumbItemText5: 'benefit',
    magnanimitydrawText: 'Un gran numero di coupon sono in attesa per voi per raccogliere',
    availablecouponstitleText: 'Prodotti coupon disponibili',
    drawbtnText: 'Get',
    universalText: 'Universal for all',
    useText: 'Use',
    limitText: 'Limit',
    fullText: 'Full',
    subtractText: 'Subtract',
    // 折扣
    discountitemText1: 'Gli sconti continuano ,',
    discountitemText2: 'Una successione di grandi benefici',
    // 组合
    commoditydiscountitemText1: 'Acquisti di portafoglio ,',
    commoditydiscountitemText2: 'Preferenze generalizzate',
    combinedpriceText: 'Prezzo combinato',
    economizeText: 'salva',
    buynowText: "Acquista ora",
    // 产品
    ourproductsText: 'I Nostri Prodott',
    productcategoryText: 'Product category',
    recommendtarText: 'Recommended',
    newText: 'Nuovo prodotto',
    salesvolumetarText: 'Volume vendite',
    pricetarText: 'Price',
    // 博客
    blogmanagementText: "Popular Blogs",
    latestblogsText: "The latest blog",
    relatedrlogsText: "Related Blogs",
    priceIncreasecommentText: "Submit comments",
    commentsectionTtxt: "area commenti",
    participatingcommentsText: "Partecipando ai commenti",
    // 论坛
    postingText: "Post pubblicato",
    topicsText: "Subject",
    replyText: "Reply",
    viewText: "View",
    lastreplyText: "Ultima risposta",
    publishText: "Publish",
    placeholdertypeText: "Please select a topic classification",
    placeholdertitleText: "Please enter a title",
    placeholdercontentsText: "Please enter content",
    fromtopicText: "From topic:",
    firstfloor: "Primo piano",
    floorText: "floor",
    fromText: "From:",
    postreplyText: "Post a reply",
    // 个人中心 - 我的订单
    myorderText: "Il mio ordine",
    mycommentsText: "My comments",
    mycollectionText: "My Collection",
    couponText: "Coupon",
    shippingaddressText: "Shipping address",
    myPostText: "My post",
    personalinformationText: "Informazioni personali",
    editText: "Edit",
    allordersText: "Tutti gli ordini",
    unpaidText: "To be paid",
    shippedText: "To be shipping",
    receivedText: "To be received",
    evaluatedText: "Da valutare",
    baidText: "Pagamento per conto",
    completedText: "Completed",
    productinfText: "Informazioni sul prodotto",
    unitpricethText: "Prezzo unitario",
    quantitythText: "Quantity",
    actualpaymentthText: "Pagamento effettivo",
    transactionstatusthText: "Transaction status",
    operationthText: "Operazione",
    ordernumberText: "Numero d'ordine",
    orderdetailsText: "Dettagli dell'ordine",
    cancelorderText: "Annulla l'ordine",
    confirmText: "OK",
    cancelText: "Cancel",
    deleteordertitle: "Sei sicuro di eliminare l'ordine corrente?",
    successfultradeText: "Transaction successed",
    paymentText: "Payment",
    confirmreceiptText: "Conferma ricevuta",
    nncommentText: 'No comment for the time',
    // 个人中心 - 我的评论
    productText: "Product",
    productdetailText: "Evaluation details",
    replyblogText: "Reply to blog:",
    //个人中心 - 收货地址
    addseliveryaddressText: "Add a shipping address",
    addaddresstitleText1: "Salvato",
    addaddresstitleText2: "gli indirizzi possono essere salvati",
    addaddresstitleText3: "indirizzi",
    defaultText: "Default",
    consigneeText: "Destinatario:",
    addressText: "Address:",
    fulladdressText: "Indirizzo dettagliato:",
    setdefaultText: "Set as default",
    mobilephoneText: "Mobile phone:",
    viewmoreText: "Vedi di più",
    replypostText: "Reply to post:",
    // 个人中心 - 个人信息
    nameLabel:"Name",
    sexlabel:"Genere",
    modifyavatarText:"Modificare avatar",
    sexmanText:"Maschio",
    sexwomanText:"female",
    secrecyText:"Confidential",
    replaceText:"Replace",
    saveText:"Save",
    oldpasswordText:"Password originale",
    newpasswordText:"Nuova password",
    confirmpasswordText:"Confirm password",
    opdpleasolderText:"Inserisci la password originale",
    newpleasolderText:"Inserisci una nuova password",
    unboundText:"unbound",
    bindingText:"Binding",
    unbindingText:"Unbind",
    // 个人中心-个人信息
    regionText:"Region",
    addconsigneleasolderText:"Si prega di compilare il nome del destinatario",
    countrypleasolderText:"Please select a country",
    provinceleasolderText:"Please select a provincie",
    citypleasolderText:"Please select a city",
    areapleasolderText:"Please select an area",
    fulladdressTextpleasolderText:"Please enter the detailed address",
    addconsignephoneleasolderText:"Si prega di inserire il numero di telefono cellulare del destinatario",
    emailpleasolderText:"Please enter email address",
    phoneText:'Numero di cellulare',
    uploadimgText:"Carica immagini",
    updateuserface:"Modificare avatar",
    uploadimgtitle1:"Supporta le immagini nei formati jpg, jpeg e png",
    uploadimgtitle2:"Dimensioni consigliate: 200 * 200 o immagine in scala equivalente",
    updateemailText:"Modify mailbox",
    updatemobileText:"Modificare il numero di cellulare",
    dialogemailtitle:"Email address",
    dialogmobiletitle:"Mobile number",
    dialogheadertitle:"Inserisci il link con il tuo account Jinge",
    continueText:"Continue",
    verificationinformation:"Informazioni di verifica",
    verificationinformationTitle1:"Per continuare, si prega di completare questa fase di verifica. Abbiamo inviato",
    verificationinformationTitle2:"Viene inviato un captcha. Per favore scrivete qui di seguito.",
    verificationcode:"codice di verifica",
    newtitle:"Nuovo",
    dialognewmobiletitle:"Inserire il nuovo numero di cellulare da associare. Fare clic per confermare la sostituzione",
    confirmpbtnText:"Confirm",
    titlecpuntryselect:"Select a country",
    hotcountrytitle:"Hot Country",
    aboutusText:"Su di noi",
    // 订单详情
    havequestionsText:"Questions",
    preferentialText:"Discount",
    enquiryText:"Inquiry",
    combinationdiscountText:"Combination discount",
    introduceText:"Introduzione",
    buyermycommentsText:"Buyermycomments",
    starText:"Star",
    yourmailboxText:"Your mailbox",
    placeholderquestionText:"Please write down your question",
    uploadimglimtText:"Si prega di caricare un file JPG/GIF/PNG. La dimensione dell'immagine non può superare 2MB.",
    submitbtnText:"Submit",
    // 购物车
    selectText:"Select",
    tipscartsText:"Prodotti selezionati (escluso il trasporto)",
    settlementText:"Settlement",
    selectallText:"Seleziona tutto",
    amountText:"Seleziona tutto",
    addtofavoritesText:"Aggiungi favoriti",
    havecollectedText:"Collected",
    tipdelecteproduct:"Sei sicuro di eliminare il prodotto corrente?",
    deleteText:"Delete",
    tipclearcart:"Sei sicuro di svuotare il carrello?",
    clearcartText:"Carrello vuoto",
    totalText:"Total",
    totaltipText:"articoli (escluso il trasporto):"
  }
}




// WEBPACK FOOTER //
// ./src/assets/language/local_it.js